import { Dispatch, SetStateAction } from "react";
import {
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import { GetLegalOnboardingRequestsFilters } from "./legal-onboarding.schema";
import { LOFRProps, getLegalOnboardingFilterRequest } from "./filter-obj";

interface ClearFiltersHandlerProps {
  setValue: UseFormSetValue<FieldValues>;
  setFiltersApplied: Dispatch<SetStateAction<boolean>>;
  submitFilters: (event: FieldValues) => Promise<void>;
  getValues: UseFormGetValues<FieldValues>;
}

export const clearFiltersHandler = ({
  setFiltersApplied,
  setValue,
  getValues,
  submitFilters,
}: ClearFiltersHandlerProps) => {
  setValue("cuitCuil", "");
  setValue("tipoSociedad", []);
  setValue("estado", []);

  submitFilters?.(getValues());
  setFiltersApplied(false);
};

interface SubmitFiltersHandlerProps {
  setOpenFilters: Dispatch<SetStateAction<boolean>>;
  setFiltersApplied: Dispatch<SetStateAction<boolean>>;
  setCurrentFilters: Dispatch<SetStateAction<GetLegalOnboardingRequestsFilters>>;
  fetchLegalOnboardingRequests: (filters?: GetLegalOnboardingRequestsFilters) => Promise<void>;
  event: FieldValues;
}

export const submitFiltersHandler = async ({
  event,
  setCurrentFilters,
  setFiltersApplied,
  fetchLegalOnboardingRequests,
  setOpenFilters,
}: SubmitFiltersHandlerProps) => {
  setFiltersApplied(true);

  const filterObj: Partial<GetLegalOnboardingRequestsFilters> =
    getLegalOnboardingFilterRequest(event as LOFRProps);

  setCurrentFilters(filterObj);

  if (!Object.keys(filterObj)?.length) setFiltersApplied(false);

  await fetchLegalOnboardingRequests(filterObj);

  setOpenFilters(false);
};
